export function sanitizeReferrer(raw: string): string | null {
  if (!raw) return null;
  try {
    const url = new URL(raw);
    return url.origin + url.pathname;
  } catch {
    return null;
  }
}
